import { memo } from 'react';
import { useStateSelector } from 'hooks';
import { useHistory } from 'react-router-dom';

import { WidgetContainer, CarIcon, LaundryIcon, SaunaIcon } from 'components';
import Box from '@material-ui/core/Box';

import { useStyles } from './style';

const ReservationWidget = () => {
  const classes = useStyles();
  const history = useHistory();
  const portal = useStateSelector((state) => state.settings.current_portal);

  const moveToServices = () => {
    let url =
      portal?.Name === 'Default'
        ? '/services'
        : portal?.Name === 'Maintenance'
        ? '/maintenance/booking-services'
        : '/';
    history.push(url);
  };

  return (
    <WidgetContainer
      themeColor="greyBlue"
      title={'Varauspalvelut'}
      action={moveToServices}
    >
      <Box padding="15px">
        <h3 className={classes.title}>Tilavaraukset</h3>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        padding={{ xs: '15px', sm: '15px', md: '30px' }}
        paddingTop={0}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          marginRight="30px"
        >
          <SaunaIcon className={classes.icons} />
          <LaundryIcon className={classes.icons} />
          <CarIcon className={classes.icons} />
        </Box>
        <Box padding="20px">
          <span className={classes.text}>
            Varaa käyttöösi taloyhtiön palveluita.
          </span>
        </Box>
      </Box>
    </WidgetContainer>
  );
};

export default memo(ReservationWidget);
